import Vue from 'vue';
import Router from 'vue-router';

import EditList from '@/views/EditList.vue';
import CreateList from '@/views/CreateList.vue';
import CreateProfile from '@/views/CreateProfile.vue';
import Login from '@/views/Login.vue';
import Logout from '@/views/Logout.vue';
import AllLists from '@/views/AllLists.vue';
import ListDetailView from '@/views/ListDetailView.vue';
import ListOwnerView from '@/views/ListOwnerView.vue';
import ProfileView from '@/views/ProfileView.vue';
import AddItem from '@/views/AddItem.vue';
import EditItem from '@/views/EditItem.vue';
import CopyItem from '@/views/CopyItem.vue';
import Home from '@/views/Home.vue';
import MyCollection from '@/views/MyCollection.vue';
import FollowersView from '@/views/Followers.vue';
import FollowsView from '@/views/Follows.vue';
import Search from '@/views/Search.vue';
import Error404View from '@/views/Error404View.vue';
import TOS from '@/views/TOS.vue';
import Privacy from '@/views/Privacy.vue';
import DMCA from '@/views/DMCA.vue';
import ItemCardDebugPage from '@/views/ItemCardDebugPage.vue';
import ActivityFeed from '@/views/ActivityFeed.vue';
import InviteCodesView from '@/views/admin/InviteCodesView.vue';
import AddEditInviteCode from '@/views/admin/AddEditInviteCode.vue';
import SignUp from '@/views/Signup.vue';
import SignupWithCode from '@/views/SignupWithCode.vue';
import ThanksForEmail from '@/views/ThanksForEmail.vue';
import * as fb from './firebase';
import { UserModule } from '@/store/modules/user';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: 'Home'
      }
    },
    {
      path: '/login',
      name: 'Login',
			component: Login,
			props: true,
      meta: {
        hideSignIn: true,
        title: 'Login'
      }
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp,
      meta: {
        hideSignIn: true,
        title: 'Sign Up'
      }
    },
    {
      path: '/signup_with_code',
      name: 'SignupWithCode',
      component: SignupWithCode,
      props: true,
      meta: {
        hideSignIn: true,
        title: 'Sign up!'
      }
    },
    {
      path: '/thanks_for_email',
      name: 'ThanksForEmail',
      component: ThanksForEmail,
      props: true,
      meta: {
        hideSignIn: true,
        title: 'Thanks!'
      }
    },
    {
      path: '/logout',
      component: Logout,
      meta: {
        title: 'Logout'
      }
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
      meta: {
        title: 'Search'
      }
    },
    {
      path: '/tos',
      name: 'TOS',
      component: TOS,
      meta: {
        title: 'Terms of Service'
      }
    },
    {
      path: '/activity',
      name: 'ActivityFeed',
      component: ActivityFeed,
      meta: {
        title: 'Activity Feed'
      }
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy,
      meta: {
        title: 'Privacy Policy'
      }
    },
    {
      path: '/dmca',
      name: 'DMCA',
      component: DMCA,
      meta: {
        title: 'DMCA'
      }
    },
    {
      path: '/create_list',
      name: 'CreateList',
      component: CreateList,
      meta: {
        requiresAuth: true,
        title: 'Create List'
      }
    },
    {
      path: '/list/id/:listId',
      component: ListDetailView,
      name: 'ListView',
      props: true
      // meta: { hideNavigation: true }
    },
    {
      path: '/l/:username/lists',
      component: AllLists,
      name: 'AllLists',
      props: true
    },
    {
      path: '/l/:username/:slug/edit',
      component: EditList,
      name: 'EditList',
      props: true,
      meta: { hideNavigation: true }
    },
    {
      path: '/l/:username/:slug/owner',
      component: ListOwnerView,
      name: 'ListOwnerView',
      props: true,
      meta: { hideNavigation: true }
    },
    {
      path: '/l/:username/:slug',
      component: ListDetailView,
      name: 'ListDetailViewWithSlug',
      props: true,
      meta: { hideNavigation: true }
    },
    {
      path: '/create_profile',
      name: 'CreateProfile',
      component: CreateProfile,
      meta: {
        requiresAuth: true,
        hideSignIn: true,
        hideNavigation: true,
        title: 'Create Profile'
      },
      props: true
    },
    {
      path: '/edit_profile',
      name: 'EditProfile',
      component: CreateProfile,
      props: {
        editMode: true
      },
      meta: {
        requiresAuth: true,
        title: 'Edit Profile'
      }
    },
    {
      path: '/profile',
      name: 'MyProfile',
      component: ProfileView,
      meta: {
        requiresAuth: true,
        title: 'My Profile'
      }
    },
    {
      path: '/u/:username/followers',
      name: 'Followers',
      props: true,
      component: FollowersView
    },
    {
      path: '/u/:username/follows',
      name: 'Follows',
      props: true,
      component: FollowsView
    },
    {
      path: '/u/:username',
      name: 'ProfileView',
      props: true,
      component: ProfileView
    },
    {
      path: '/add_item',
      name: 'AddItem',
      props: true,
      component: AddItem,
      meta: {
        requiresAuth: true,
        hideNavigation: true,
        hideHeaderOnMobile: true,
        title: 'Add Item'
      }
    },
    {
      path: '/edit_item',
      name: 'EditItem',
      props: true,
      component: EditItem,
      meta: {
        hideNavigation: true,
        hideHeaderOnMobile: true,
        title: 'Edit Item'
      }
    },
    {
      path: '/copy_item',
      name: 'CopyItem',
      props: true,
      component: CopyItem,
      meta: { hideNavigation: true }
    },
    {
      path: '/my_collection',
      name: 'MyCollection',
      component: MyCollection,
      meta: {
        requiresAuth: true,
        title: 'My Collection'
      }
    },
    {
      path: '/debug/item_cards',
      name: 'ItemCardDebugPage',
      component: ItemCardDebugPage
    },
    {
      path: '/admin/invites',
      name: 'InviteCodesView',
      component: InviteCodesView
    },
    {
      path: '/admin/invites/add',
      name: 'AddInviteCode',
      component: AddEditInviteCode
    },
    {
      path: '/admin/invites/:inviteCodeString',
      name: 'EditInviteCode',
      component: AddEditInviteCode,
      props: true
    },
    {
      path: '*',
      name: '404',
      component: Error404View
    }
  ]
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const requiresAdmin = to.matched.some(x => x.meta.requiresAdmin);

  const currentUser = fb.auth.currentUser;

  if ((requiresAdmin || requiresAuth) && !currentUser) {
    next('/login?redir=' + encodeURIComponent(to.fullPath));
  } else if (requiresAdmin) {
    if (UserModule.userProfile.isAdmin) {
      next();
    } else {
      next('/unauthorized');
    }
  } else if (requiresAuth && currentUser) {
    next();
  } else {
    next();
  }
});

export default router;
